import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Wynn_Resort_Al_Marjan_Island.webp';

const Project_eighteen = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Wynn Al Marjan Island</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The UAE's first integrated resort and casino, developed by Wynn Resorts on Al Marjan Island in Ras Al Khaimah. A landmark
                mega-development spanning hotel towers, entertainment venues, casino, and supporting infrastructure. GEMCO active
                across multiple packages under multiple MEP contractors.</p>
              <p>MAIN CONTRACTOR : Multiple</p>
              <p>MEP CONTRACTOR : ALEC / ALEMCO / Al Futtaim Engineering / Khansaheb</p>
              <p>GEMCO SCOPE OF WORKS : Multiple packages — CHW, electrical, plumbing and
                mechanical works across various buildings and zones</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_eighteen